var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"auth-dialog-index",attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.cadasterModal),callback:function ($$v) {_vm.cadasterModal=$$v},expression:"cadasterModal"}},[_c('form-cadaster',{on:{"closeDialog":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }